<template>
  <div class="registration-payment" v-loading="loading" :element-loading-text="loadingText">
    <div class="registration-title">
      <div class="blue-title">报名缴费</div>
<!--      <div v-if="!isView" class="edit" @click="edit">编辑/保存</div>-->
    </div>
    <div v-if="feeResult && loaded" class="already-paid">
      <img src="../../../../../../assets/icons/already_paid.png" alt="">
    </div>
    <div v-if="loaded" class="card-out">
      <div class="card-content">
        <div class="line">
          <div class="key">报名批次：</div>
          <div class="value">{{ enrollFeeDetail.batchName }}</div>
        </div>
        <div class="line">
          <div class="key">姓名：</div>
          <div class="value">{{ enrollFeeDetail.trueName }}</div>
        </div>
        <div class="line">
          <div class="key">身份证号：</div>
          <div class="value">{{ enrollFeeDetail.cardNo }}</div>
        </div>
        <div class="line">
          <div class="key">报考教学点：</div>
          <div class="value">{{ enrollFeeDetail.siteName }}</div>
        </div>
        <div class="line">
          <div class="key">报名费用：</div>
          <div class="value">{{ enrollFeeDetail.fee }}元</div>
        </div>
        <div class="line">
          <div class="key">备注：</div>
          <div class="value">
            <el-input
              v-if="!isView"
              type="textarea"
              :rows="1"
              v-model="enrollFeeDetail.remark"
            ></el-input>
            <span v-else>{{ enrollFeeDetail.remark }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loaded" class="btn-group">
      <el-button
        v-if="!isView"
        type="primary"
        @click="enrollFee(1)"
      >置为已缴费</el-button>
      <el-button
        v-if="!isView"
        @click="enrollFee(0)"
      >置为未缴费</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RegistrationPayment',
  props: {
    studentId: {
      type: String,
      default: ''
    },
    isView: {
      type: Boolean,
      default: false
    },
    feeResult: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      enrollFeeDetail: {
        batchName: '',
        trueName: '',
        cardNo: '',
        siteName: '',
        fee: '',
        remark: ''
      },
      isEdit: false,
      loaded: false,
      loading: true,
      loadingText: '加载中，请稍等...'
    }
  },
  methods: {
    getEnrollFeeDetail (code) {
      this.loading = true
      this.loadingText = '加载中，请稍等...'
      this.$ajax({
        url: '/workspace/manager/enrolling/student/enrollFeeDetail',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.studentId
        })
      }).then(response => {
        if (response.data) {
          const res = response.data
          if (res.errorCode === 0) {
            this.enrollFeeDetail = res.enrollFeeDetail
            if (typeof code === 'number') {
              this.$emit('fee-change', code)
            }
          } else {
            this.$message.error(res.message)
          }
        }
      }).finally(() => {
        this.loaded = true
        this.loading = false
      })
    },
    enrollFee (code) {
      this.loadingText = '操作中，请稍等...'
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/enrollFee',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.studentId,
          feeStatus: code,
          remark: this.enrollFeeDetail.remark
        })
      }).then(response => {
        if (response.data) {
          const res = response.data
          if (res.errorCode === 0) {
            this.loading = false
            this.$emit('fee-change', code)
            this.$message.success(res.message || '设置成功')
          } else {
            this.loading = false
            this.$message.error(res.message)
          }
        }
      }, () => {
        this.loading = false
      })
    },
    edit () {
      if (this.isEdit) {
        this.loadingText = '保存中，请稍等...'
        this.loading = true
        this.$ajax({
          url: '/workspace/manager/enrolling/student/enrollFeeRemarkUpdate',
          method: 'post',
          data: this.$qs.stringify({
            studentId: this.studentId,
            remark: this.enrollFeeDetail.remark
          })
        }).then(response => {
          if (response.data) {
            const res = response.data
            if (res.errorCode === 0) {
              this.isEdit = false
              this.$message.success(res.message || '设置成功')
            } else {
              this.$message.error(res.message)
            }
          }
        }).finally(() => {
          this.isEdit = false
          this.loading = false
        })
      } else {
        this.isEdit = true
      }
    }
  },
  mounted () {
    this.getEnrollFeeDetail()
  }
}
</script>

<style scoped lang="scss">
.registration-payment {
  padding: 15px 25px 61px;
  height: 482px;
  position: relative;
  .blue-title {
    color: #0D59A7;
    position: relative;
    font-weight: 550;
    padding-left: 10px;
    font-size: 13px;
    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 20px;
      background-color: #02A7F0;
      margin-right: 10px;
      position: absolute;
      left: 2px;
    }
  }
  .already-paid {
    position: absolute;
    top: 13px;
    right: 263px;
    & > img {
      width: 123px;
      height: 115px;
      -o-object-fit: contain;
      object-fit: contain;
    }
  }
  & > .registration-title {
    display: flex;
    justify-content: space-between;
    & > .edit {
      color: #027DB4;
      cursor: pointer;
      text-decoration: underline;
      font-size: 12px;
      padding-right: 20px;
    }
  }
  & > .card-out {
    height: 267px;
    & > .card-content {
      width: 450px;
      margin: 30px auto 0;
      padding: 6px 30px;
      max-height: 271.5px;
      overflow: auto;
      background-color: #FDFBFA;
      border: 1px solid #A47851;
      border-radius: 5px;
      & > .line {
        width: 100%;
        margin-top: 16px;
        display: flex;
        align-items: center;
        font-size: 17px;
        &:first-child {
          margin-top: 0;
        }
        & > .key {
          display: inline-block;
          width: 120px;
          color: #0F4C7F;
          flex-shrink: 0;
          font-weight: 550;
          font-size: 13px;
        }
        & > .value {
          flex: 1;
          display: inline-block;
          color: #547FA3;
          font-size: 12px;
          font-weight: 500;
          ::v-deep  .el-textarea {
            .el-textarea__inner {
              height: 50px !important;
            }
          }
        }
      }
    }
  }
  & > .btn-group {
    margin-top: 30px;
    height: 56.5px;
    text-align: center;
    & > .el-button {
      margin-left: 20px;
    }
  }
}
</style>
